'use client';

import React__default from 'react';
import { colors } from '../../Colors/index.js';

var Avatar = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 25 : _b, _c = _a.rectColor, rectColor = _c === void 0 ? colors.grey[95] : _c, _d = _a.fillColor, fillColor = _d === void 0 ? colors.grey[80] : _d;
    return (React__default.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: size, height: size, viewBox: '0 0 25 25', fill: 'none' },
        React__default.createElement("rect", { width: '25', height: '25', rx: '12.5', fill: rectColor }),
        React__default.createElement("path", { d: 'M12.5 6.10001C10.7325 6.10001 9.3 7.53254 9.3 9.30001V9.83334C9.3 11.6008 10.7325 13.0333 12.5 13.0333C14.2675 13.0333 15.7 11.6008 15.7 9.83334V9.30001C15.7 7.53254 14.2675 6.10001 12.5 6.10001ZM12.499 14.6333C10.3624 14.6333 7.6211 15.789 6.8323 16.8146C6.34483 17.4487 6.80887 18.3667 7.60834 18.3667H17.3906C18.1901 18.3667 18.6541 17.4487 18.1667 16.8146C17.3779 15.7895 14.6355 14.6333 12.499 14.6333Z', fill: fillColor })));
};
var Avatars = { Avatar: Avatar };

export { Avatar, Avatars as default };
//# sourceMappingURL=index.js.map
